import React, { useEffect, useState } from "react";
import { getFirestore, setWithExpiry, getWithExpiry } from "../../config/firebase";
import logoWhatsapp from "../../assets/img/logoWhatsapp.png";
import "./whatsapp.scss";
import WhatsAppModal from "./WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { getWhatsAppUrl, getUtmParams, saveUtmParams } from "../../config/whatsappConfig";
import { sendPostRequest } from "../../config/desol";

const WhatsAppFlotante = () => {
  // Eliminado: flag de visibilidad, ahora siempre visible
  const [whatsappIndividual, setWhatsappIndividual] = useState(null);

  // Procesar UTM parameters al cargar el componente
  useEffect(() => {
    saveUtmParams();
  }, []);

  useEffect(() => {
    const cargarDatosInformacion = async () => {
      // Intentar recuperar los datos de localStorage con expiración
      const datosLocales = getWithExpiry("hyundai-informacion");
      if (datosLocales) {
        // Buscar el documento "whatsapp" en los datos locales
        const whatsappDoc = datosLocales.find((doc) => doc.id === "whatsapp");
        if (whatsappDoc) {
          setWhatsappIndividual(whatsappDoc.url);
        }
      } else {
        // Si no hay datos en localStorage, hacer la llamada a Firestore
        const db = getFirestore();
        const vehicles = db.collection("hyundai-informacion");
        try {
          const querySnapshot = await vehicles.get();
          const datosCompletos = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));

          // Buscar el documento "whatsapp" en los datos de Firestore
          const whatsappDoc = datosCompletos.find((doc) => doc.id === "whatsapp");
          if (whatsappDoc) {
            setWhatsappIndividual(whatsappDoc.url);
          }

          // Guardar los datos en localStorage con expiración
          setWithExpiry("hyundai-informacion", datosCompletos);
        } catch (error) {
          console.error("Error al obtener datos de Firestore: ", error);
        }
      }
    };
    cargarDatosInformacion();
  }, []);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  // Función para construir la URL de tracking con UTM (usada en mensaje de WhatsApp)
  const buildTrackingUrlWithUtm = (utmSource, utmMedium, utmCampaign, utmContent) => {
    const source = utmSource || "MEDIOS_TRADICIONALES";
    const medium = utmMedium || "Sitio Web";
    const campaign = utmCampaign || "MEDIOS_TRADICIONALES";
    const trackingParams = new URLSearchParams();
    trackingParams.append("utm_source", source);
    trackingParams.append("utm_medium", medium);
    trackingParams.append("utm_campaign", campaign);
    trackingParams.append("utm_id", "MEDIOS_TRADICIONALES");
    if (utmContent) trackingParams.append("utm_content", utmContent);
    return `https://oficial.montironi.com/consultas/?${trackingParams.toString()}`;
  };

  // Función simplificada para obtener la URL correcta según el UTM source
  const getWhatsAppUrlFromConfig = () => {
    console.log("=== WhatsAppFlotante Debug ===");
    console.log("Current URL:", window.location.href);

    const utmParams = getUtmParams();
    console.log("UTM Params:", utmParams);

    const defaultPhone = "5493516825130";
    const defaultBaseUrl =
      whatsappIndividual || `https://api.whatsapp.com/send?phone=${defaultPhone}&text=Hola%20Montironi!`;

    // Si hay UTM en la URL/sessionStorage, incluir la URL de tracking en el mensaje
    const hasUtm = utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign;
    if (hasUtm) {
      const query = new URLSearchParams(window.location.search);
      const utmContent = query.get("utm_content") || sessionStorage.getItem("utm_content");
      const trackingUrl = buildTrackingUrlWithUtm(
        utmParams.utm_source,
        utmParams.utm_medium,
        utmParams.utm_campaign,
        utmContent
      );
      const message = `Hola, me gustaría hacer una consulta.\n${trackingUrl}`;
      const params = new URLSearchParams({ phone: defaultPhone, text: message });
      const url = `https://api.whatsapp.com/send?${params.toString()}`;
      console.log("Generated WhatsApp URL with UTM tracking:", url);
      return url;
    }

    // Si hay utm_source con config específica (ej. tiktok), usar whatsappConfig
    if (utmParams.utm_source) {
      const whatsappUrl = getWhatsAppUrl(utmParams);
      console.log("Generated WhatsApp URL from config:", whatsappUrl);
      return whatsappUrl;
    }

    console.log("Using original WhatsApp URL:", whatsappIndividual);
    return defaultBaseUrl;
  };

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      // Obtener parámetros UTM de la URL (o sessionStorage) para Firestore, Desol y construcción de URLs
      const query = new URLSearchParams(window.location.search);
      const utmParams = getUtmParams();
      const utm_source = query.get("utm_source") || utmParams.utm_source || sessionStorage.getItem("utm_source") || "";
      const utm_medium = query.get("utm_medium") || utmParams.utm_medium || sessionStorage.getItem("utm_medium") || "";
      const utm_campaign =
        query.get("utm_campaign") || utmParams.utm_campaign || sessionStorage.getItem("utm_campaign") || "";
      const utm_content = query.get("utm_content") || utmParams.utm_content || sessionStorage.getItem("utm_content") || "";
      const utm_term = query.get("utm_term") || utmParams.utm_term || sessionStorage.getItem("utm_term") || "";
      const utm_id = query.get("utm_id") || utmParams.utm_id || sessionStorage.getItem("utm_id") || "";
      const utm_brand = query.get("utm_brand") || utmParams.utm_brand || sessionStorage.getItem("utm_brand") || "";

      // Guardar en Firestore - consultas/validaciones (incluyendo todos los UTMs que usamos)
      await updateData({
        ...values,
        utm_source,
        utm_medium,
        utm_campaign,
        utm_term,
        utm_content,
        utm_id,
        utm_brand,
      });

      // Detectar marca desde selección del usuario, UTM o URL
      const pathname = window.location.pathname.toLowerCase();
      const slugMatch = pathname.match(/consultas\/(\w+)/);
      const slugBrand = slugMatch && slugMatch[1] ? slugMatch[1] : "";
      const brand = (values.marcaInteres || utm_source || slugBrand || "").toLowerCase();
      const campaignByBrand = {
        peugeot: "C12_PEUGEOT_LANDINGS",
        jeep: "C12_JEEP_LANDINGS",
        ford: "C12_FORD_LANDINGS",
        fiat: "C12_FIAT_LANDINGS",
        hyundai: "C12_HYUNDAI_LANDINGS",
        gac: "C12_GAC_LANDINGS",
      };
      const resolvedCampaign = campaignByBrand[brand] || "C12_HYUNDAI_LANDINGS";

      // Preparar datos para Desol
      const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");
      const brandLabel = capitalize(brand);

      const dataForDesol = {
        Apellido: values.nombre,
        Email: values.email,
        Telefono: values.celular,
        Canal: "WhatsApp",
        Motivo: `Consulta por WhatsApp - ${brandLabel}${utm_source ? ` - ${utm_source}` : ""}`,
        OrigenLead: `${process.env.REACT_APP_LANDING} - ${brandLabel}${utm_source ? ` - ${utm_source}` : ""}`,
        CommercialCampaign: utm_medium,
        Campaign: resolvedCampaign,
        Modelo_Pedido: `Consulta WhatsApp - ${brandLabel}`,
      };

      // Enviar a Desol
      try {
        await sendPostRequest(process.env.REACT_APP_DESOL_URL, dataForDesol);
        console.log("Datos enviados exitosamente a Desol");
      } catch (desolError) {
        console.error("Error al enviar a Desol:", desolError);
        // No bloqueamos el flujo si falla Desol, solo mostramos el error en consola
      }

      setOpen(false);

      // Función para construir URLs de WhatsApp dinámicamente con parámetros UTM
      const buildWhatsAppUrl = (brandKey) => {
        const phoneNumbers = {
          ford: "5493513527817",
          fiat: "5493513525903",
          peugeot: "5493513793585",
          jeep: "5493513743833",
          hyundai: "5493517385093",
          gac: "5493517915736",
        };

        const phone = phoneNumbers[brandKey] || phoneNumbers.hyundai;

        // Usar UTM de la URL (reutilizando la misma lógica que getWhatsAppUrlFromConfig)
        const trackingUrl = buildTrackingUrlWithUtm(utm_source, utm_medium, utm_campaign, utm_content);

        // Construir el mensaje con la URL incluida
        const message = `Hola, me gustaría hacer una consulta.\n${trackingUrl}`;

        const baseUrl = "https://api.whatsapp.com/send";
        const params = new URLSearchParams({
          phone: phone,
          text: message,
        });

        return `${baseUrl}?${params.toString()}`;
      };

      // URLs de WhatsApp por marca (construidas dinámicamente)
      const whatsappUrls = {
        ford: buildWhatsAppUrl("ford"),
        fiat: buildWhatsAppUrl("fiat"),
        peugeot: buildWhatsAppUrl("peugeot"),
        jeep: buildWhatsAppUrl("jeep"),
        hyundai: buildWhatsAppUrl("hyundai"),
        gac: buildWhatsAppUrl("gac"),
      };

      // Obtener la URL según la marca seleccionada
      const whatsappUrl = whatsappUrls[brand] || getWhatsAppUrlFromConfig();

      // Console.log para verificar el link antes de redirigir
      console.log(`🚀 [WhatsApp Flotante] Redirigiendo a WhatsApp`);
      console.log(`🔗 Marca seleccionada: ${brand ? brand.toUpperCase() : "No especificada"}`);
      console.log(`📱 URL de WhatsApp que se usará:`, whatsappUrl);

      window.location.href = whatsappUrl;
    } catch (error) {
      console.error("Error al procesar el formulario:", error);
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  // Siempre visible: ignoramos el flag mostrarWhatsapp

  return (
    <div className="whatsapp-container">
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
      <button className="btn-whatsapp-flotante" onClick={() => setOpen(true)} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;

